import { Stack, Typography } from '@mui/material';
import Grid2 from '@mui/material/Grid2';

import { colors } from 'src/global/styles/colors';

import { AverageSaleChart } from './AverageSaleChart';
import { KPIOverviewCards } from './KPIOverviewCards';
import { TotalNodesSoldChart } from './TotalNodesSoldChart';
import { TotalRevenueChart } from './TotalRevenueChart';

export function OverviewSection() {
  return (
    <Stack spacing={3}>
      <Typography
        variant='h5'
        sx={{
          fontFamily: 'Gotham',
          fontWeight: 700,
          fontSize: '24px',
          color: colors.white,
          lineHeight: 1.17,
        }}>
        Overview
      </Typography>

      {/* KPI Cards */}
      <KPIOverviewCards />

      {/* Charts Row */}
      <Grid2 container spacing={3}>
        <Grid2 size={{ xs: 12, lg: 6 }}>
          <TotalNodesSoldChart />
        </Grid2>
        <Grid2 size={{ xs: 12, lg: 6 }}>
          <TotalRevenueChart />
        </Grid2>
        <Grid2 size={{ xs: 12, lg: 12 }}>
          <AverageSaleChart />
        </Grid2>
      </Grid2>
    </Stack>
  );
}
